module.exports = __webpack_public_path__ + "ff53555d93f3fafe58fd471ac30da6e4.svg";